import Nullstack from 'nullstack';
export default function IconMarkdownOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-markdown-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 5h10a2 2 0 0 1 2 2v10"
  }), "   ", Nullstack.element("path", {
    d: "M19 19h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 1.85 -1.995"
  }), "   ", Nullstack.element("path", {
    d: "M7 15v-6l2 2l.995 -.995m1.005 .995v4"
  }), "   ", Nullstack.element("path", {
    d: "M17.5 13.5l.5 -.5m-2 -.997v-3.003"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}